import { GeneratedBuildData } from 'web/data/models'

export const GENERATED_MAIN: GeneratedBuildData = JSON.parse(`
{
    "specsById": {
      "67a45712-192e-4916-ad57-d9a13124fea6": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Healer",
        "name": "Discipline",
        "id": "67a45712-192e-4916-ad57-d9a13124fea6",
        "shortName": "Disc",
        "icon_name": "spell_holy_powerwordshield",
        "spellIds": [
          "dc70ac3c-b104-4afb-8d23-e5fabb8a6530",
          "f13e1cb6-bc98-416f-850e-c01b0030d32b",
          "78ab8e9d-7506-499f-a82a-091756d305d2",
          "bacb0d1f-6f61-476f-930b-90c9711836ee"
        ],
        "talentIds": []
      },
      "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Tank",
        "name": "Guardian",
        "id": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
        "shortName": "Guard",
        "icon_name": "ability_racial_bearform",
        "spellIds": [
          "fefc79c3-74ce-40e9-9656-52d2fabb625e",
          "e941017d-4474-40c5-8a0b-a72a99a1baf4"
        ],
        "talentIds": []
      },
      "8fceebcc-a93b-4692-81ea-331b2e59d43d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "role": "Tank",
        "name": "Protection",
        "id": "8fceebcc-a93b-4692-81ea-331b2e59d43d",
        "shortName": "Prot",
        "icon_name": "ability_paladin_shieldofthetemplar",
        "spellIds": [
          "a42ac7df-6560-4126-ab9b-c8dc3900978b"
        ],
        "talentIds": []
      },
      "72947601-4270-4e1e-b917-25aacaa6d3e0": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Healer",
        "name": "Restoration",
        "id": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "shortName": "Resto",
        "icon_name": "spell_nature_healingtouch",
        "spellIds": [
          "25346dfb-4290-45e7-8052-b4e885ddfb7e",
          "3e0bde1d-6430-47c6-9fa2-7e70b5f804dc",
          "55783ba5-09a5-4b80-9c77-a5bc6283d088",
          "35c2206c-689f-4194-b7cf-37cbcf5356ab"
        ],
        "talentIds": [
          "f8e49a4b-ced6-4584-aef5-a4cc7cbb686d",
          "d99f4df1-d142-4909-a952-7b5ea93906c7"
        ]
      },
      "6c233e8c-5bd4-4ece-9fb8-529a1e78759b": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Ranged DPS",
        "name": "Balance",
        "id": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
        "shortName": "Balance",
        "icon_name": "spell_nature_starfall",
        "spellIds": [
          "baca27d3-f4a6-47c2-be00-f07e2b575b24",
          "1e5ad5a2-7784-4fe5-b50b-c0a65d7db880"
        ],
        "talentIds": []
      },
      "b72fb4f9-413a-4222-8569-b3cb8e5e67f2": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Melee DPS",
        "name": "Frost",
        "id": "b72fb4f9-413a-4222-8569-b3cb8e5e67f2",
        "shortName": "Frost",
        "icon_name": "spell_deathknight_frostpresence",
        "spellIds": [
          "a9d614b7-18a4-4ca0-a934-32e84f87ac60"
        ],
        "talentIds": []
      },
      "d122a0b5-d857-4bc5-a456-c7250f8f6690": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Healer",
        "name": "Holy",
        "id": "d122a0b5-d857-4bc5-a456-c7250f8f6690",
        "shortName": "Holy",
        "icon_name": "spell_holy_guardianspirit",
        "spellIds": [
          "aeb49287-7ee4-4ddd-b9a8-16a3f8500358",
          "ca996ba0-a0b2-478b-95de-7a6996dc3742",
          "75bcded4-a545-4296-8e45-e6802c1117b3",
          "47023d71-7356-4c76-9153-0e7a9ea1df54"
        ],
        "talentIds": [
          "b50cfd45-7dba-4fcd-8e72-feb0ef624a8a"
        ]
      },
      "83b7651d-c296-4a15-9932-b4012144b6ec": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Tank",
        "name": "Protection",
        "id": "83b7651d-c296-4a15-9932-b4012144b6ec",
        "shortName": "Prot",
        "icon_name": "ability_warrior_defensivestance",
        "spellIds": [
          "dff976d9-8ef6-485e-bf48-ac305ab178d4"
        ],
        "talentIds": []
      },
      "1df0b300-a31e-4ebc-be57-a909f82bab4b": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Ranged DPS",
        "name": "Elemental",
        "id": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "shortName": "Ele",
        "icon_name": "spell_nature_lightning",
        "spellIds": [
          "1b6511cf-f251-4ea4-a498-5f704245c447",
          "cfa6f550-c73e-4cca-99ae-cb597c248b4d"
        ],
        "talentIds": [
          "b71d476d-fcd1-4089-8f05-41f3ab040c9f",
          "a92016f1-a0e6-4fee-94ed-537fa3a97e1f"
        ]
      },
      "e1af3b62-ddf5-4369-a528-dab8ab94d366": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "role": "Healer",
        "name": "Holy",
        "id": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "shortName": "Holy",
        "icon_name": "spell_holy_holybolt",
        "spellIds": [
          "850a87b9-59e7-4dcb-8e9e-ce2bf3e6c3bd",
          "e41cea3b-6d65-47c9-ac29-c11aa8c1cc5a",
          "8ac0fe12-4c14-4e2b-ac5c-3b6317dc1169",
          "331c4193-2566-43fb-ab6f-ab3bf325649c",
          "7acb028f-02cc-48b8-abed-e0f75f1635c3"
        ],
        "talentIds": [
          "50bb4dcb-67ba-4918-99f4-973cf6a8ea6a",
          "d2063e10-90b1-448a-b5c0-1d370c71c837"
        ]
      },
      "e92b34bc-aa34-4579-a543-2ece2545d981": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Melee DPS",
        "name": "Arms",
        "id": "e92b34bc-aa34-4579-a543-2ece2545d981",
        "shortName": "Arms",
        "icon_name": "ability_warrior_savageblow",
        "spellIds": [
          "7dcf7756-720b-4ebf-825b-79f077d4f039"
        ],
        "talentIds": []
      },
      "4ac0a1e4-3352-49e9-b455-faa83312526d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "role": "Melee DPS",
        "name": "Retribution",
        "id": "4ac0a1e4-3352-49e9-b455-faa83312526d",
        "shortName": "Ret",
        "icon_name": "spell_holy_auraoflight",
        "spellIds": [
          "5ef053f3-4036-4d62-89c9-979bb910ad87"
        ],
        "talentIds": []
      },
      "08853913-0c47-4ca1-aec0-e93206a6ee45": {
        "classId": "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
        "role": "Melee DPS",
        "name": "Havoc",
        "id": "08853913-0c47-4ca1-aec0-e93206a6ee45",
        "shortName": "Havoc",
        "icon_name": "ability_demonhunter_specdps",
        "spellIds": [
          "98672799-84c5-429c-8925-4d3397527e01"
        ],
        "talentIds": []
      },
      "51daa0f0-df16-4983-ae44-e11b5f9b3edb": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Healer",
        "name": "Restoration",
        "id": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "shortName": "Resto",
        "icon_name": "spell_nature_magicimmunity",
        "spellIds": [
          "b7a13dfd-6cd8-4611-a291-c8f3848034a3",
          "f60cb8fe-14c1-40ca-8e48-ac2a7d5e9e53",
          "45c7a0ed-9cd6-4c1b-884c-9f4a18b13edb",
          "76d13866-3729-4afe-a828-01defed08a4d",
          "cadbe329-0d56-41d6-b584-f0984dc62384",
          "b6e57eb2-3f07-406b-8e1f-3db0843cff27"
        ],
        "talentIds": [
          "84df57e1-4be9-4b3e-a34c-70da96eb7645",
          "d52a3dcd-5ed4-4899-8b8a-62c6dd034c87",
          "33ae2e3c-3947-4934-ac4e-568efee29afc"
        ]
      },
      "575905ae-cdc7-44c8-946c-861d50111b6d": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "role": "Melee DPS",
        "name": "Feral",
        "id": "575905ae-cdc7-44c8-946c-861d50111b6d",
        "shortName": "Feral",
        "icon_name": "ability_druid_catform",
        "spellIds": [
          "ea3411a1-5932-41a1-afdf-0e4591f7e36c",
          "420ed3be-57c9-4db7-8ddc-8b2b0c5ffffc"
        ],
        "talentIds": []
      },
      "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "role": "Melee DPS",
        "name": "Enhancement",
        "id": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9",
        "shortName": "Enh",
        "icon_name": "spell_shaman_improvedstormstrike",
        "spellIds": [
          "c5b13d8b-58a4-4258-81af-ac84d0bc4551"
        ],
        "talentIds": [
          "87738407-8a7b-432c-8e2e-9c4cb2d58b11"
        ]
      },
      "da2dc773-9412-4b11-ab2b-7d06e200b9d3": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "role": "Healer",
        "name": "Mistweaver",
        "id": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "shortName": "MW",
        "icon_name": "spell_monk_mistweaver_spec",
        "spellIds": [
          "046b39bc-29e0-4964-989e-48f112e27e9f",
          "8175ecd3-3459-4e43-a548-a82c72438ca2",
          "787d2fd6-ec33-40a5-85a1-565acc981155",
          "ce31e945-0c73-4d77-8fca-5a0696f2aa41"
        ],
        "talentIds": [
          "fed26e25-05e0-4674-b127-01ed2eb8ac2a"
        ]
      },
      "1b478900-c50e-49f6-b9b1-d2fedfb10c2b": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Melee DPS",
        "name": "Unholy",
        "id": "1b478900-c50e-49f6-b9b1-d2fedfb10c2b",
        "shortName": "Unholy",
        "icon_name": "spell_deathknight_unholypresence",
        "spellIds": [
          "e7aa873a-32af-48d6-bd00-f9e597c2b8b2"
        ],
        "talentIds": []
      },
      "34735ecf-bf9e-4225-bb6e-ee617b024b70": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "role": "Tank",
        "name": "Blood",
        "id": "34735ecf-bf9e-4225-bb6e-ee617b024b70",
        "shortName": "Blood",
        "icon_name": "spell_deathknight_bloodpresence",
        "spellIds": [
          "2c42c8de-597a-4eca-89e6-d9352c6ef35f"
        ],
        "talentIds": []
      },
      "48c27d79-2cc2-4674-bfd0-9a471f6c7ced": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "role": "Ranged DPS",
        "name": "Shadow",
        "id": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced",
        "shortName": "Shadow",
        "icon_name": "spell_shadow_shadowwordpain",
        "spellIds": [
          "d5dbdfcf-cd05-4b45-9966-2bb2a8ef90b2"
        ],
        "talentIds": []
      },
      "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "role": "Melee DPS",
        "name": "Fury",
        "id": "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d",
        "shortName": "Fury",
        "icon_name": "ability_warrior_innerrage",
        "spellIds": [
          "6da0313b-3ecb-4c8d-b29d-2eaed694f65b"
        ],
        "talentIds": []
      }
    },
    "patchInfo": {
      "buildVersion": "920_1"
    },
    "talentsById": {
      "33ae2e3c-3947-4934-ac4e-568efee29afc": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Wind Rush Totem",
        "id": "33ae2e3c-3947-4934-ac4e-568efee29afc",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "d52a3dcd-5ed4-4899-8b8a-62c6dd034c87": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Ascendance",
        "id": "d52a3dcd-5ed4-4899-8b8a-62c6dd034c87",
        "shortName": "Asc",
        "icon_name": "spell_fire_elementaldevastation",
        "game_id": 114052
      },
      "d2063e10-90b1-448a-b5c0-1d370c71c837": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Holy Avenger",
        "id": "d2063e10-90b1-448a-b5c0-1d370c71c837",
        "shortName": "HA",
        "icon_name": "ability_paladin_holyavenger",
        "game_id": 105809
      },
      "87738407-8a7b-432c-8e2e-9c4cb2d58b11": {
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9",
        "name": "Wind Rush Totem",
        "id": "87738407-8a7b-432c-8e2e-9c4cb2d58b11",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "f8e49a4b-ced6-4584-aef5-a4cc7cbb686d": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Inner Peace",
        "id": "f8e49a4b-ced6-4584-aef5-a4cc7cbb686d",
        "shortName": "IP",
        "icon_name": "ability_druid_dreamstate",
        "game_id": 197073
      },
      "d99f4df1-d142-4909-a952-7b5ea93906c7": {
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Incarnation: Tree of Life",
        "id": "d99f4df1-d142-4909-a952-7b5ea93906c7",
        "shortName": "Tree",
        "icon_name": "ability_druid_improvedtreeform",
        "game_id": 33891
      },
      "b71d476d-fcd1-4089-8f05-41f3ab040c9f": {
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "name": "Ancestral Guidance",
        "id": "b71d476d-fcd1-4089-8f05-41f3ab040c9f",
        "shortName": "Guide",
        "icon_name": "ability_shaman_ancestralguidance",
        "game_id": 108281
      },
      "b50cfd45-7dba-4fcd-8e72-feb0ef624a8a": {
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690",
        "name": "Holy Word: Salvation",
        "id": "b50cfd45-7dba-4fcd-8e72-feb0ef624a8a",
        "shortName": "Salv",
        "icon_name": "ability_priest_archangel",
        "game_id": 265202
      },
      "84df57e1-4be9-4b3e-a34c-70da96eb7645": {
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Ancestral Protection Totem",
        "id": "84df57e1-4be9-4b3e-a34c-70da96eb7645",
        "shortName": "APT",
        "icon_name": "spell_nature_reincarnation",
        "game_id": 207399
      },
      "50bb4dcb-67ba-4918-99f4-973cf6a8ea6a": {
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Avenging Crusader",
        "id": "50bb4dcb-67ba-4918-99f4-973cf6a8ea6a",
        "shortName": "Crusa",
        "icon_name": "ability_paladin_veneration",
        "game_id": 216331
      },
      "fed26e25-05e0-4674-b127-01ed2eb8ac2a": {
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "name": "Invoke Chi-Ji, the Red Crane",
        "id": "fed26e25-05e0-4674-b127-01ed2eb8ac2a",
        "shortName": "Chi-ji",
        "icon_name": "inv_pet_cranegod",
        "game_id": 325197
      },
      "a92016f1-a0e6-4fee-94ed-537fa3a97e1f": {
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "name": "Wind Rush Totem",
        "id": "a92016f1-a0e6-4fee-94ed-537fa3a97e1f",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      }
    },
    "spellsById": {
      "55783ba5-09a5-4b80-9c77-a5bc6283d088": {
        "affectedByModifierIds": [],
        "name": "Tranquility",
        "cooldown": 180,
        "id": "55783ba5-09a5-4b80-9c77-a5bc6283d088",
        "shortName": "Tranq",
        "icon_name": "spell_nature_tranquility",
        "game_id": 740
      },
      "420ed3be-57c9-4db7-8ddc-8b2b0c5ffffc": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "420ed3be-57c9-4db7-8ddc-8b2b0c5ffffc",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "850a87b9-59e7-4dcb-8e9e-ce2bf3e6c3bd": {
        "affectedByModifierIds": [],
        "name": "Avenging Wrath",
        "cooldown": 120,
        "id": "850a87b9-59e7-4dcb-8e9e-ce2bf3e6c3bd",
        "shortName": "Wings",
        "icon_name": "spell_holy_avenginewrath",
        "game_id": 31884
      },
      "787d2fd6-ec33-40a5-85a1-565acc981155": {
        "affectedByModifierIds": [],
        "name": "Invoke Yu'lon, the Jade Serpent",
        "cooldown": 180,
        "id": "787d2fd6-ec33-40a5-85a1-565acc981155",
        "shortName": "Yulon",
        "icon_name": "ability_monk_dragonkick",
        "game_id": 322118
      },
      "1b6511cf-f251-4ea4-a498-5f704245c447": {
        "affectedByModifierIds": [],
        "talentId": "b71d476d-fcd1-4089-8f05-41f3ab040c9f",
        "name": "Ancestral Guidance",
        "cooldown": 120,
        "id": "1b6511cf-f251-4ea4-a498-5f704245c447",
        "shortName": "Guide",
        "icon_name": "ability_shaman_ancestralguidance",
        "game_id": 108281
      },
      "cfa6f550-c73e-4cca-99ae-cb597c248b4d": {
        "affectedByModifierIds": [],
        "talentId": "a92016f1-a0e6-4fee-94ed-537fa3a97e1f",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "cfa6f550-c73e-4cca-99ae-cb597c248b4d",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "75bcded4-a545-4296-8e45-e6802c1117b3": {
        "affectedByModifierIds": [],
        "talentId": "b50cfd45-7dba-4fcd-8e72-feb0ef624a8a",
        "name": "Holy Word: Salvation",
        "cooldown": 720,
        "id": "75bcded4-a545-4296-8e45-e6802c1117b3",
        "shortName": "Salv",
        "icon_name": "ability_priest_archangel",
        "game_id": 265202
      },
      "e41cea3b-6d65-47c9-ac29-c11aa8c1cc5a": {
        "affectedByModifierIds": [],
        "talentId": "50bb4dcb-67ba-4918-99f4-973cf6a8ea6a",
        "name": "Avenging Crusader",
        "cooldown": 120,
        "id": "e41cea3b-6d65-47c9-ac29-c11aa8c1cc5a",
        "shortName": "Crusa",
        "icon_name": "ability_paladin_veneration",
        "game_id": 216331
      },
      "046b39bc-29e0-4964-989e-48f112e27e9f": {
        "affectedByModifierIds": [],
        "talentId": "fed26e25-05e0-4674-b127-01ed2eb8ac2a",
        "name": "Invoke Chi-Ji, the Red Crane",
        "cooldown": 180,
        "id": "046b39bc-29e0-4964-989e-48f112e27e9f",
        "shortName": "Chi-ji",
        "icon_name": "inv_pet_cranegod",
        "game_id": 325197
      },
      "f60cb8fe-14c1-40ca-8e48-ac2a7d5e9e53": {
        "affectedByModifierIds": [],
        "name": "Chain Harvest",
        "cooldown": 90,
        "modifierId": "915d1163-de60-4feb-8c61-fdc7f6b1a417",
        "id": "f60cb8fe-14c1-40ca-8e48-ac2a7d5e9e53",
        "shortName": "Harvest",
        "icon_name": "warlock_charredremains",
        "game_id": 320674
      },
      "e941017d-4474-40c5-8a0b-a72a99a1baf4": {
        "affectedByModifierIds": [
          "84c81ea5-9ed2-4607-96cd-15be63764e20"
        ],
        "name": "Convoke the Spirits",
        "cooldown": 120,
        "modifierId": "2f4c75cc-8c8d-48ec-968e-72b90050b705",
        "id": "e941017d-4474-40c5-8a0b-a72a99a1baf4",
        "shortName": "Con",
        "icon_name": "ability_ardenweald_druid",
        "game_id": 323764
      },
      "a42ac7df-6560-4126-ab9b-c8dc3900978b": {
        "affectedByModifierIds": [],
        "name": "Ashen Hallow",
        "cooldown": 240,
        "modifierId": "e39625ed-4e08-476b-aaac-90a495d7beb5",
        "id": "a42ac7df-6560-4126-ab9b-c8dc3900978b",
        "shortName": "AH",
        "icon_name": "ability_revendreth_paladin",
        "game_id": 316958
      },
      "25346dfb-4290-45e7-8052-b4e885ddfb7e": {
        "affectedByModifierIds": [],
        "talentId": "d99f4df1-d142-4909-a952-7b5ea93906c7",
        "name": "Incarnation: Tree of Life",
        "cooldown": 180,
        "id": "25346dfb-4290-45e7-8052-b4e885ddfb7e",
        "shortName": "Tree",
        "icon_name": "ability_druid_improvedtreeform",
        "game_id": 33891
      },
      "a9d614b7-18a4-4ca0-a934-32e84f87ac60": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "a9d614b7-18a4-4ca0-a934-32e84f87ac60",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      },
      "3e0bde1d-6430-47c6-9fa2-7e70b5f804dc": {
        "affectedByModifierIds": [
          "84c81ea5-9ed2-4607-96cd-15be63764e20"
        ],
        "name": "Convoke the Spirits",
        "cooldown": 120,
        "modifierId": "2f4c75cc-8c8d-48ec-968e-72b90050b705",
        "id": "3e0bde1d-6430-47c6-9fa2-7e70b5f804dc",
        "shortName": "Con",
        "icon_name": "ability_ardenweald_druid",
        "game_id": 323764
      },
      "ce31e945-0c73-4d77-8fca-5a0696f2aa41": {
        "affectedByModifierIds": [],
        "name": "Fallen Order",
        "cooldown": 180,
        "modifierId": "8a99ad10-a7f5-4ce9-9fc6-c5c1e0486710",
        "id": "ce31e945-0c73-4d77-8fca-5a0696f2aa41",
        "shortName": "Fallen",
        "icon_name": "ability_revendreth_monk",
        "game_id": 326860
      },
      "cadbe329-0d56-41d6-b584-f0984dc62384": {
        "affectedByModifierIds": [],
        "name": "Spirit Link Totem",
        "cooldown": 180,
        "id": "cadbe329-0d56-41d6-b584-f0984dc62384",
        "shortName": "SLT",
        "icon_name": "spell_shaman_spiritlink",
        "game_id": 98008
      },
      "35c2206c-689f-4194-b7cf-37cbcf5356ab": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "35c2206c-689f-4194-b7cf-37cbcf5356ab",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "dff976d9-8ef6-485e-bf48-ac305ab178d4": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "dff976d9-8ef6-485e-bf48-ac305ab178d4",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "8ac0fe12-4c14-4e2b-ac5c-3b6317dc1169": {
        "affectedByModifierIds": [],
        "talentId": "d2063e10-90b1-448a-b5c0-1d370c71c837",
        "name": "Holy Avenger",
        "cooldown": 180,
        "id": "8ac0fe12-4c14-4e2b-ac5c-3b6317dc1169",
        "shortName": "HA",
        "icon_name": "ability_paladin_holyavenger",
        "game_id": 105809
      },
      "fefc79c3-74ce-40e9-9656-52d2fabb625e": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 60,
        "id": "fefc79c3-74ce-40e9-9656-52d2fabb625e",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "f13e1cb6-bc98-416f-850e-c01b0030d32b": {
        "affectedByModifierIds": [],
        "name": "Big Ramp",
        "cooldown": 180,
        "id": "f13e1cb6-bc98-416f-850e-c01b0030d32b",
        "shortName": "B. Ramp",
        "icon_name": "ability_bastion_priest",
        "game_id": 325013
      },
      "98672799-84c5-429c-8925-4d3397527e01": {
        "affectedByModifierIds": [],
        "name": "Darkness",
        "cooldown": 180,
        "id": "98672799-84c5-429c-8925-4d3397527e01",
        "shortName": "Dark",
        "icon_name": "ability_demonhunter_darkness",
        "game_id": 196718
      },
      "47023d71-7356-4c76-9153-0e7a9ea1df54": {
        "affectedByModifierIds": [],
        "name": "Divine Hymn",
        "cooldown": 180,
        "id": "47023d71-7356-4c76-9153-0e7a9ea1df54",
        "shortName": "Hymn",
        "icon_name": "spell_holy_divinehymn",
        "game_id": 64843
      },
      "dc70ac3c-b104-4afb-8d23-e5fabb8a6530": {
        "affectedByModifierIds": [],
        "name": "Power Word: Barrier",
        "cooldown": 180,
        "id": "dc70ac3c-b104-4afb-8d23-e5fabb8a6530",
        "shortName": "PW:B",
        "icon_name": "spell_holy_powerwordbarrier",
        "game_id": 62618
      },
      "1e5ad5a2-7784-4fe5-b50b-c0a65d7db880": {
        "affectedByModifierIds": [
          "84c81ea5-9ed2-4607-96cd-15be63764e20"
        ],
        "name": "Convoke the Spirits",
        "cooldown": 120,
        "modifierId": "2f4c75cc-8c8d-48ec-968e-72b90050b705",
        "id": "1e5ad5a2-7784-4fe5-b50b-c0a65d7db880",
        "shortName": "Con",
        "icon_name": "ability_ardenweald_druid",
        "game_id": 323764
      },
      "d5dbdfcf-cd05-4b45-9966-2bb2a8ef90b2": {
        "affectedByModifierIds": [],
        "name": "Vampiric Embrace",
        "cooldown": 120,
        "id": "d5dbdfcf-cd05-4b45-9966-2bb2a8ef90b2",
        "shortName": "VE",
        "icon_name": "spell_shadow_unsummonbuilding",
        "game_id": 15286
      },
      "45c7a0ed-9cd6-4c1b-884c-9f4a18b13edb": {
        "affectedByModifierIds": [],
        "talentId": "84df57e1-4be9-4b3e-a34c-70da96eb7645",
        "name": "Ancestral Protection Totem",
        "cooldown": 300,
        "id": "45c7a0ed-9cd6-4c1b-884c-9f4a18b13edb",
        "shortName": "APT",
        "icon_name": "spell_nature_reincarnation",
        "game_id": 207399
      },
      "e7aa873a-32af-48d6-bd00-f9e597c2b8b2": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "e7aa873a-32af-48d6-bd00-f9e597c2b8b2",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      },
      "78ab8e9d-7506-499f-a82a-091756d305d2": {
        "affectedByModifierIds": [],
        "name": "Small Ramp",
        "cooldown": 180,
        "id": "78ab8e9d-7506-499f-a82a-091756d305d2",
        "shortName": "S. Ramp",
        "icon_name": "spell_shadow_shadowfiend",
        "game_id": 34433
      },
      "6da0313b-3ecb-4c8d-b29d-2eaed694f65b": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "6da0313b-3ecb-4c8d-b29d-2eaed694f65b",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "8175ecd3-3459-4e43-a548-a82c72438ca2": {
        "affectedByModifierIds": [],
        "name": "Revival",
        "cooldown": 180,
        "id": "8175ecd3-3459-4e43-a548-a82c72438ca2",
        "shortName": "Rev",
        "icon_name": "spell_monk_revival",
        "game_id": 115310
      },
      "aeb49287-7ee4-4ddd-b9a8-16a3f8500358": {
        "affectedByModifierIds": [],
        "name": "Boon of the Ascended",
        "cooldown": 180,
        "modifierId": "d8d3935a-52cd-4883-933c-3737063b143d",
        "id": "aeb49287-7ee4-4ddd-b9a8-16a3f8500358",
        "shortName": "Boon",
        "icon_name": "ability_bastion_priest",
        "game_id": 325013
      },
      "ca996ba0-a0b2-478b-95de-7a6996dc3742": {
        "affectedByModifierIds": [],
        "name": "Symbol of Hope",
        "cooldown": 180,
        "id": "ca996ba0-a0b2-478b-95de-7a6996dc3742",
        "shortName": "Hope",
        "icon_name": "spell_holy_symbolofhope",
        "game_id": 64901
      },
      "7acb028f-02cc-48b8-abed-e0f75f1635c3": {
        "affectedByModifierIds": [],
        "name": "Ashen Hallow",
        "cooldown": 240,
        "modifierId": "e39625ed-4e08-476b-aaac-90a495d7beb5",
        "id": "7acb028f-02cc-48b8-abed-e0f75f1635c3",
        "shortName": "AH",
        "icon_name": "ability_revendreth_paladin",
        "game_id": 316958
      },
      "b6e57eb2-3f07-406b-8e1f-3db0843cff27": {
        "affectedByModifierIds": [],
        "talentId": "d52a3dcd-5ed4-4899-8b8a-62c6dd034c87",
        "name": "Ascendance",
        "cooldown": 180,
        "id": "b6e57eb2-3f07-406b-8e1f-3db0843cff27",
        "shortName": "Asc",
        "icon_name": "spell_fire_elementaldevastation",
        "game_id": 114052
      },
      "331c4193-2566-43fb-ab6f-ab3bf325649c": {
        "affectedByModifierIds": [],
        "name": "Aura Mastery",
        "cooldown": 180,
        "id": "331c4193-2566-43fb-ab6f-ab3bf325649c",
        "shortName": "AM",
        "icon_name": "spell_holy_auramastery",
        "game_id": 31821
      },
      "c5b13d8b-58a4-4258-81af-ac84d0bc4551": {
        "affectedByModifierIds": [],
        "talentId": "87738407-8a7b-432c-8e2e-9c4cb2d58b11",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "c5b13d8b-58a4-4258-81af-ac84d0bc4551",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "b7a13dfd-6cd8-4611-a291-c8f3848034a3": {
        "affectedByModifierIds": [],
        "name": "Healing Tide Totem",
        "cooldown": 180,
        "id": "b7a13dfd-6cd8-4611-a291-c8f3848034a3",
        "shortName": "HTT",
        "icon_name": "ability_shaman_healingtide",
        "game_id": 108280
      },
      "7dcf7756-720b-4ebf-825b-79f077d4f039": {
        "affectedByModifierIds": [],
        "name": "Rallying Cry",
        "cooldown": 180,
        "id": "7dcf7756-720b-4ebf-825b-79f077d4f039",
        "shortName": "RC",
        "icon_name": "ability_warrior_rallyingcry",
        "game_id": 97462
      },
      "2c42c8de-597a-4eca-89e6-d9352c6ef35f": {
        "affectedByModifierIds": [],
        "name": "Anti-Magic Zone",
        "cooldown": 120,
        "id": "2c42c8de-597a-4eca-89e6-d9352c6ef35f",
        "shortName": "AMZ",
        "icon_name": "spell_deathknight_antimagiczone",
        "game_id": 51052
      },
      "ea3411a1-5932-41a1-afdf-0e4591f7e36c": {
        "affectedByModifierIds": [
          "84c81ea5-9ed2-4607-96cd-15be63764e20"
        ],
        "name": "Convoke the Spirits",
        "cooldown": 120,
        "modifierId": "2f4c75cc-8c8d-48ec-968e-72b90050b705",
        "id": "ea3411a1-5932-41a1-afdf-0e4591f7e36c",
        "shortName": "Con",
        "icon_name": "ability_ardenweald_druid",
        "game_id": 323764
      },
      "5ef053f3-4036-4d62-89c9-979bb910ad87": {
        "affectedByModifierIds": [],
        "name": "Ashen Hallow",
        "cooldown": 240,
        "modifierId": "e39625ed-4e08-476b-aaac-90a495d7beb5",
        "id": "5ef053f3-4036-4d62-89c9-979bb910ad87",
        "shortName": "AH",
        "icon_name": "ability_revendreth_paladin",
        "game_id": 316958
      },
      "baca27d3-f4a6-47c2-be00-f07e2b575b24": {
        "affectedByModifierIds": [],
        "name": "Stampeding Roar",
        "cooldown": 120,
        "id": "baca27d3-f4a6-47c2-be00-f07e2b575b24",
        "shortName": "Roar",
        "icon_name": "spell_druid_stampedingroar_cat",
        "game_id": 106898
      },
      "76d13866-3729-4afe-a828-01defed08a4d": {
        "affectedByModifierIds": [],
        "talentId": "33ae2e3c-3947-4934-ac4e-568efee29afc",
        "name": "Wind Rush Totem",
        "cooldown": 120,
        "id": "76d13866-3729-4afe-a828-01defed08a4d",
        "shortName": "WRT",
        "icon_name": "ability_shaman_windwalktotem",
        "game_id": 192077
      },
      "bacb0d1f-6f61-476f-930b-90c9711836ee": {
        "affectedByModifierIds": [],
        "name": "Ramp",
        "cooldown": 90,
        "id": "bacb0d1f-6f61-476f-930b-90c9711836ee",
        "shortName": "Ramp",
        "icon_name": "spell_holy_rapture",
        "game_id": 47536
      }
    },
    "changelog": [
      "- Symbol changed from 5min to 3min"
    ],
    "modifiersById": {
      "e39625ed-4e08-476b-aaac-90a495d7beb5": {
        "meta": "",
        "name": "Ashen Hallow",
        "id": "e39625ed-4e08-476b-aaac-90a495d7beb5",
        "shortName": "AH",
        "eligibleSpecIds": [
          "4ac0a1e4-3352-49e9-b455-faa83312526d",
          "8fceebcc-a93b-4692-81ea-331b2e59d43d",
          "e1af3b62-ddf5-4369-a528-dab8ab94d366"
        ],
        "icon_name": "ability_revendreth_paladin",
        "game_id": 316958
      },
      "84c81ea5-9ed2-4607-96cd-15be63764e20": {
        "meta": "",
        "name": "Celestial Spirits",
        "id": "84c81ea5-9ed2-4607-96cd-15be63764e20",
        "shortName": "Celest",
        "eligibleSpecIds": [
          "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
          "72947601-4270-4e1e-b917-25aacaa6d3e0",
          "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
          "575905ae-cdc7-44c8-946c-861d50111b6d"
        ],
        "icon_name": "ability_ardenweald_druid",
        "game_id": 354118
      },
      "915d1163-de60-4feb-8c61-fdc7f6b1a417": {
        "meta": "",
        "name": "Chain Harvest",
        "id": "915d1163-de60-4feb-8c61-fdc7f6b1a417",
        "shortName": "Harvest",
        "eligibleSpecIds": [
          "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
        ],
        "icon_name": "warlock_charredremains",
        "game_id": 320674
      },
      "d8d3935a-52cd-4883-933c-3737063b143d": {
        "meta": "",
        "name": "Boon of the Ascended",
        "id": "d8d3935a-52cd-4883-933c-3737063b143d",
        "shortName": "Boon",
        "eligibleSpecIds": [
          "d122a0b5-d857-4bc5-a456-c7250f8f6690"
        ],
        "icon_name": "ability_bastion_priest",
        "game_id": 325013
      },
      "8a99ad10-a7f5-4ce9-9fc6-c5c1e0486710": {
        "meta": "",
        "name": "Fallen Order",
        "id": "8a99ad10-a7f5-4ce9-9fc6-c5c1e0486710",
        "shortName": "Fallen",
        "eligibleSpecIds": [
          "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
        ],
        "icon_name": "ability_revendreth_monk",
        "game_id": 326860
      },
      "2f4c75cc-8c8d-48ec-968e-72b90050b705": {
        "meta": "",
        "name": "Convoke the Spirits",
        "id": "2f4c75cc-8c8d-48ec-968e-72b90050b705",
        "shortName": "Con",
        "eligibleSpecIds": [
          "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
          "72947601-4270-4e1e-b917-25aacaa6d3e0",
          "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
          "575905ae-cdc7-44c8-946c-861d50111b6d"
        ],
        "icon_name": "ability_ardenweald_druid",
        "game_id": 323764
      }
    }
  }
`)
